import { RootState } from 'store/reducer';

export const selectAsset = (assetId?: string) => (state: RootState) =>
  assetId ? state.assets?.[assetId] : undefined;

export const selectAssets = (state: RootState) => state.assets;
